export default __webpack_public_path__ + "static/media/news.88002c4e.mp4";